import styled from 'styled-components';
import { OCardStandardContentAlignment, OCardStandardPadding } from './OCardStandard.types';

interface WrapperProps {
  contentAlignment: OCardStandardContentAlignment;
  padding: OCardStandardPadding;
  isClickable: boolean;
}

interface ContentWrapperProps {
  contentAlignment: OCardStandardContentAlignment;
  padding: OCardStandardPadding;
}

export const Wrapper = styled.article<WrapperProps>`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: var(--t-cards-border-radius, 14px);
  overflow: hidden;
  background-color: var(--t-brand-bg-color);
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
  transition: transform 0.3s ease;

  &:hover {
    transform: ${({ isClickable }) => (isClickable ? 'scale(1.02)' : 'none')};
  }

  ${({ padding }) =>
    padding === OCardStandardPadding.EntireCard &&
    `
    padding: 1rem;

    @media (min-width: 768px) {
      padding: 1.5rem;
    }
  `}
`;

export const MediaWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: var(--t-images-border-radius, 14px);
`;

export const ContentWrapper = styled.div<ContentWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: ${({ contentAlignment }) =>
    contentAlignment === OCardStandardContentAlignment.Centered ? 'center' : 'flex-start'};
  text-align: ${({ contentAlignment }) =>
    contentAlignment === OCardStandardContentAlignment.Centered ? 'center' : 'left'};

  ${({ padding }) =>
    padding === OCardStandardPadding.ContentOnly &&
    `
    padding: 1rem;

    @media (min-width: 768px) {
      padding: 1.5rem;
    }
  `}

  @media (min-width: 768px) {
    gap: 1rem;
  }
`;

export const EyebrowWrapper = styled.div`
  width: 100%;
`;

export const SubheaderWrapper = styled.div`
  width: 100%;
`;

export const AccentLineWrapper = styled.div`
  width: 100%;
`;

export const BodyWrapper = styled.div`
  width: 100%;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 1rem;
  }
`;

export const ButtonWrapper = styled.div`
  flex: 1;
`;

export const TagWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-top: 0.5rem;
`;
